import { FC } from 'react';
import styled from 'styled-components';

import NetworkIcon from '@/components/NetworkIcon';
import RestrictedContent from '@/components/RestrictedContent';
import { Td } from '@/components/Table';
import Text from '@/components/Text';
import { ChannelFinancesResource } from '@/types/resources';
import { numFormatter } from '@/utils/helpers';

const excludedChannels = [
  'Everyday Life',
  'Creative Ideas',
  'NoLimit Crafts',
  'Amazing World & Architecture',
  'Peaceful Century',
];

export const Description = styled.div`
  display: flex;
  align-items: center;
  svg {
    position: absolute;
    top: -2px;
    left: -2px;
  }
`;

export const DescriptionText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 20px;
`;

export const ImageWrap = styled.div`
  position: relative;
`;

export const Image = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  flex-shrink: 0;
  border: 1px solid rgba(144, 144, 144, 0.3);
`;

export const Tr = styled.tr`
  ${Td} {
    padding: 28px 20px;
  }
`;

interface Props {
  channel: ChannelFinancesResource;
}

const FinancesTableRow: FC<Props> = ({ channel }) => {
  const { total_revenue, published_revenue, total_views, total_engaged_views } =
    channel;

  return (
    <Tr>
      <Td>
        <Description>
          {!!channel.thumbnail && (
            <ImageWrap>
              <Image
                src={channel.thumbnail}
                alt={channel.name + ' thumbnail'}
                loading="lazy"
              />
              <NetworkIcon type={channel.network} />
            </ImageWrap>
          )}

          <DescriptionText>
            <Text $type="smallBold">{channel.name}</Text>
            <Text
              $type="extraSmall"
              $color="gray"
              as="a"
              href={channel.url}
              target="_blank"
            >
              {channel.url}
            </Text>
          </DescriptionText>
        </Description>
      </Td>
      <Td>
        {excludedChannels.includes(channel.name) ? (
          <RestrictedContent hideForAll />
        ) : (
          <RestrictedContent permission="view finances">
            {total_revenue ? `$ ${numFormatter(total_revenue, 1, 2)}` : '-'}
          </RestrictedContent>
        )}
      </Td>
      <Td>
        {excludedChannels.includes(channel.name) ? (
          <RestrictedContent hideForAll />
        ) : (
          <RestrictedContent permission="view finances">
            {published_revenue
              ? `$ ${numFormatter(published_revenue, 1, 2)}`
              : '-'}
          </RestrictedContent>
        )}
      </Td>
      <Td>{total_views ? numFormatter(total_views) : '-'}</Td>
      <Td>{total_engaged_views ? numFormatter(total_engaged_views) : '-'}</Td>
    </Tr>
  );
};

export default FinancesTableRow;
